module.exports = __webpack_public_path__ + "static/media/manageeventB.a14f4656.svg";